export const deepFind = (arr, cb) => {
  const queue = arr
  while (queue.length) {
    const item = queue.shift()
    if (cb(item)) {
      return item
    }
    queue.push(...item.children)
  }
  return null
}
